import { call, put } from 'redux-saga/effects';
import processError from '../../../utils/processError';
import { loadSmevCheckListFailed, loadSmevCheckListSuccessful } from '../actions';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import makeRequest from '../../../utils/makeRequest';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { OK } from '../../../configs/serverStatusCodes';
import { BACKEND_URL } from '../../../configs';

export default function* loadSmevCheckList(action) {
  try {
    const pool = {
      subject_type: 'application',
      subject_id: action.payload,
    };
    const url = `${BACKEND_URL}/resources/checks/`;
    const dataResponse = yield makeRequest(url, pool, action, 'GET', true);
    if (dataResponse.status === OK) {
      const data = yield dataResponse.json();
      yield put(loadSmevCheckListSuccessful(data));
      yield call(resolveActionPromise(action, data));
    } else {
      yield put(loadSmevCheckListFailed());
      yield call(rejectActionPromise(action));
    }
  } catch (e) {
    yield put(loadSmevCheckListFailed());
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  }
}
